import React from 'react'
import AddLearn from '../../Blogs/addpage'
import Footer from '../Home/footer/Footer'

function Addata() {
  return (
    <div>
      <AddLearn/>
      <Footer/>
    </div>
  )
}

export default Addata;